import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";

import Delete from "../../../../components/Delete";
import useNasGroup from "../../../../hooks/useNasGroup";
import { useDialog } from "../../../../contexts/DialogContext";
import DeleteMappedNasModal from "./DeleteMappedNasModal";

const Paper = styled(MuiPaper)(spacing);

const MappedPolicy = ({ nasGroupId }) => {
  const { openDialog } = useDialog();
  const currentPayload = {
    filters: [
      {
        fieldName: "nasGroupId",
        fieldValue: nasGroupId,
        op: "eq",
        isJoin: true,
        dataType: "int",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [],
  };
  const [payload, setPayload] = useState(currentPayload);
  const { isLoading, getNasGroupMaps, nasGroupMaps, paging } = useNasGroup();

  const fetchData = async () => {
    await getNasGroupMaps(payload);
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  useEffect(() => {
    fetchData();
  }, [payload]);

  const deleteItemClick = async (nasGroupMapId) => {
    return openDialog(
      "delete_mapped_nas",
      "Delete Mapped Nas",
      <DeleteMappedNasModal nasGroupMapId={nasGroupMapId} refreshPage={fetchData} />,
    );
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return <Delete rowClick={onClick} deleteItemClick={() => deleteItemClick(params.id)} />;
      },
    },
    {
      field: "nas",
      headerName: "Nas Name",
      valueGetter: (params) => params.nasName,
      type: "string",
      width: 300,
    },
  ];
  const onPageChange = (page) => {
    console.log(page, "pagepage");
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };
  return (
    <Card mb={6}>
      <Paper>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            columns={columns}
            rows={nasGroupMaps}
            rowCount={paging.totalNumberOfRecords}
            getRowId={(row) => row["nasGroupMapId"]}
            loading={isLoading}
            rowsPerPageOptions={[5]}
            pagination
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMode="server"
            onPageChange={(page) => onPageChange(page)}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            checkboxSelection
            sortingMode="server"
            //sortModel={sortModel}
            //onSortModelChange={handleSortModelChange}
          />
        </div>
      </Paper>
    </Card>
  );
};

export default MappedPolicy;
